import React, { useState } from "react";
import JobListingPurchasePanel from "../../components/employer/JobListingPurchasePanel";

const PricingPage = () => {
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [expandedFeatures, setExpandedFeatures] = useState({
        sponsored: false,
        enterprise: false,
    });
    const tallySalesFormUrl = "https://tally.so/r/wb6krg";

    const toggleFeatures = (plan) => {
        setExpandedFeatures((prev) => ({
            ...prev,
            [plan]: !prev[plan],
        }));
    };

    const handleUpgrade = (plan) => {
        // For now, just show an alert
        alert(`Upgrade to ${plan} plan - Coming soon!`);
    };

    return (
        <div className="min-h-screen bg-white py-12 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="text-center mb-12">
                    <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">
                        Flexible healthcare hiring
                    </h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        Get instant access to a specialised pool of 300+ medical professionals on a single platform built exclusively for Doctors.
                    </p>
                </div>

                {/* Pricing Cards */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
                    {/* Free Starter Plan */}
                    <div 
                        className={`bg-white rounded-3xl border-2 p-5 flex flex-col cursor-pointer hover:shadow-xl transition-all duration-300 ${
                            selectedPlan === "Free Starter" ? "border-black" : "border-gray-200 hover:border-gray-300"
                        }`}
                        onClick={() => setSelectedPlan("Free Starter")}
                    >
                        <div className="mb-4">
                            <h3 className="text-lg font-bold text-black mb-1.5">Free Starter</h3>
                            <p className="text-sm text-gray-600">Your first step to faster hiring.</p>
                        </div>

                        <ul className="flex-1 space-y-2.5 mb-5">
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">First job ad free (visible for 5 days)</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Public company profile</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">1 seat in your workspace</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Direct messaging</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Applicant tracking & prioritisation tools</span>
                            </li>
                        </ul>

                        <div className="mb-4">
                            <div className="text-2xl font-bold text-black mb-1.5">Free</div>
                        </div>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                handleUpgrade("Free Starter");
                            }}
                            className="w-full bg-black text-white rounded-full py-3 font-medium hover:opacity-90 transition-opacity"
                        >
                            Current Plan
                        </button>
                    </div>

                    {/* Sponsored Jobs Plan */}
                    <div 
                        className={`bg-white rounded-3xl border-2 p-5 flex flex-col cursor-pointer hover:shadow-xl transition-all duration-300 ${
                            selectedPlan === "Sponsored Jobs" ? "border-black" : "border-gray-200 hover:border-gray-300"
                        }`}
                        onClick={() => setSelectedPlan("Sponsored Jobs")}
                    >
                        <div className="mb-4">
                            <div className="flex items-center gap-2 mb-1.5">
                                <h3 className="text-lg font-bold text-black">Sponsored Jobs</h3>
                                <span className="bg-gray-800 text-white text-xs px-2 py-0.5 rounded-full">
                                    Best visibility
                                </span>
                            </div>
                            <p className="text-sm text-gray-600">For companies hiring fast.</p>
                        </div>

                        <ul className="flex-1 space-y-2.5 mb-4">
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Premium listing</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Top-of-search placement</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Team collaboration of 5-Seats</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">View all features</span>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        toggleFeatures("sponsored");
                                    }}
                                    className="ml-auto"
                                >
                                    <svg
                                        className={`w-5 h-5 text-gray-500 transition-transform ${expandedFeatures.sponsored ? "rotate-180" : ""}`}
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                    >
                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                                    </svg>
                                </button>
                            </li>
                            {expandedFeatures.sponsored && (
                                <div className="ml-9 space-y-2">
                                    <li className="text-gray-700">Job analytics and matching</li>
                                    <li className="text-gray-700">Applicant tracking & candidate sorting tools</li>
                                    <li className="text-gray-700">Direct messaging</li>
                                </div>
                            )}
                        </ul>

                        <div onClick={(e) => e.stopPropagation()}>
                            <JobListingPurchasePanel
                                onPurchaseRecorded={async (purchaseData) => {
                                    // Wait a moment for database to commit, then refresh page to update all components
                                    setTimeout(() => {
                                        window.location.reload();
                                    }, 1500);
                                }}
                            />
                        </div>
                    </div>

                    {/* Enterprise Plan */}
                    <div 
                        className={`bg-white rounded-3xl border-2 p-5 flex flex-col cursor-pointer hover:shadow-xl transition-all duration-300 ${
                            selectedPlan === "Enterprise" ? "border-black" : "border-gray-200 hover:border-gray-300"
                        }`}
                        onClick={() => setSelectedPlan("Enterprise")}
                    >
                        <div className="mb-4">
                            <h3 className="text-lg font-bold text-black mb-1.5">Enterprise</h3>
                            <p className="text-sm text-gray-600">For hospital groups and healthcare networks.</p>
                        </div>

                        <ul className="flex-1 space-y-2.5 mb-4">
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Unlimited listings & member seats</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Premium homepage and search visibility</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">Dedicated account support</span>
                            </li>
                            <li className="flex items-start gap-3">
                                <svg className="w-6 h-6 text-black flex-shrink-0 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                                    <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                </svg>
                                <span className="text-gray-700">All Sponsored jobs features and more</span>
                            </li>
                        </ul>

                        <div className="mb-4">
                            <div className="text-2xl font-bold text-black mb-1.5">Custom</div>
                        </div>

                        <button
                            onClick={(e) => {
                                e.stopPropagation();
                                window.open(tallySalesFormUrl, "_blank");
                            }}
                            className="w-full bg-black text-white rounded-full py-3 font-medium hover:opacity-90 transition-opacity"
                        >
                            Talk to Sales
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingPage;

